<template src="./Add.html"></template>

<script>
import { showAlert } from "@/utils/helpers";

export default {
  created() {
    this.$store.dispatch("lookups/GetItemByProcedure", "خدمات تحاليل");
    // this.$store.dispatch("lookups/GetItemByProcedure", "خدمات قسم العناية بالبشرة");
    // this.$store.dispatch("lookups/getAllItemPriceList", "خدمات");

    this.$store.dispatch("lookups/getDoctors");
  },
  computed: {
    itemPriceList() {
      return this.$store.state.lookups.itemPriceList || [];
    },
    doctors() {
      return [
        ...this.$store.state.lookups.doctors];
    },
  },
  data() {
    return {
      appointments: [],
      patient: {
        fullName: null,
        fileNo: null,
      },
      allowedDays: [],
      patients: [],
      selectedPatient: {
        fullName: null,
        fileNo: null
      },
      showResult: false,
      showBtn: false,
      dialog: false,
      customerDialog: false,
      searchTrem: null,

      vm: {
        patientId: null,
        invoiceDate: null,
        appointmentId: null,
        appointmentDate: null,
        doctorId: null,
        services: [],
      },
      service: {
        serviceName: null,
        price: null,
      },

      servicePrice: null,

      indexItem: null,
      editFlag: false,
      headersService: [
        { text: 'اسم التحليل', value: 'serviceName' },
        { text: 'السعر ', value: 'price' },
        { text: 'الاجراءات', value: 'actions', sortable: false },
      ],

      customer : {
        fullName: null,
        phoneNo: null,
      }
    };
  },
  methods: {
    getPrice() {
      this.service.price = null;
      let service = this.itemPriceList.find(x => x.itemName == this.service.serviceName);
      this.service.price = service.price;

    },
    getAppointments() {
      this.appointments = [];
      this.vm.appointmentDate = null;
      this.$store
        .dispatch("invoicesAnalysis/getAppointments", {
          patientId: this.vm.patientId,
          doctorId: this.vm.doctorId,
        })
        .then((res) => {
          this.appointments = res;
        })
        .catch(() => { });
    },


    confirm() {
      this.$refs.form.validate().then(valid => {
        if (valid) {
          if (this.vm.services.length == 0) {
            showAlert(`يجب ادخال عنصر واحد على الاقل`);
            return false;
          }
          if(this.vm.appointmentId != null){

            this.vm.appointmentDate = this.appointments.find(x => x.value == this.vm.appointmentId).label
          }
          this.$store
            .dispatch("invoicesAnalysis/add", this.vm)
            .then(() => {
              this.back();
            })
            .catch(() => { });
        } else {
          showAlert(`الرجاء التحقق من تعبئة جميع الحقول  `);

        }
      });

    },
    AddItem() {
      if (this.service.serviceName == null) {
        showAlert(`يجب اختيار التحليل `);
        return false;
      }
      if (this.service.price == null) {
        showAlert(`يجب ادخال السعر `);
        return false;
      }
      var Index = this.vm.services.findIndex(x => x.serviceName == this.service.serviceName);
      if (Index != -1) {
        showAlert(`لا يمكن اضافة نفس التحليل اكثر من مرة   `);
        return false;
      }
      let service = this.itemPriceList.find(x => x.itemName == this.service.serviceName);
      this.vm.services.push({
        serviceName: this.service.serviceName,
        serviceCode: service.itemCode,
        price: this.service.price,
      });
      this.service.serviceName = null;
      this.service.price = null;
      //this.$refs.info.reset();
    },

    removeItem(index) {
      this.vm.services.splice(index, 1);
    },
    back() {
      this.$emit("back");
    },

    SearchPatient() {
      this.showResult = false;
      this.patients = [];
      this.selectedPatient.fullName = null;
      this.selectedPatient.fileNo = null;
      this.vm = {
        patientId: null,
        invoiceDate: null,
        appointmentId: null,
        // invoiceTypeId: null,
        services: [],
        // analysis: []
      };
      if (this.searchTrem == null || this.searchTrem == "" || this.searchTrem.length < 9) {
        showAlert(`الرجاء ادخال رقم الهاتف`);
        return false;
      }

      this.$store
        .dispatch("appointments/search", { searchTrem: this.searchTrem })
        .then((res) => {

          if (res.statusCode == 1) {
            this.showResult = true
            this.patients = res.patients;
            this.dialog = true;
          }
        })
        .catch(() => { });
    },
    CreateCustomer() {
      
      if (this.customer.fullName === null || this.customer.phoneNo === null) {
        showAlert(`الرجاء التحقق من تعبئة البيانات `);
        return false;
      }

      this.$store
        .dispatch("invoicesAnalysis/addPatient", this.customer)
        .then((res) => {
          if (res.statusCode == 1) {
              this.searchTrem = res.patient.phoneNo;
            // this.showResult = true
            // this.patients = res.patients;
            this.vm.patientId = res.patient.id;
            this.selectedPatient.fileNo = res.patient.fileNo;
            this.selectedPatient.fullName = res.patient.fullName;
            // phoneNo
          }
        })
        .catch(() => { })
        .finally(()=>{
          this.CloseCustomerDialog();
        });
    },
    CloseCustomerDialog(){
      this.customer = {
        fullName:null,
        phoneNo:null,
      }
      this.customerDialog = false;
    },
    confirmDialog() {
      let that = this;
      this.patients.forEach((el) => {
        if (that.vm.patientId == el.id) {

          that.selectedPatient = el
          return el
        }
      });

      this.dialog = false
    },

  },
};
</script>